import { runtimeConfig } from "config/runtimeConfig";
import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { AppContext } from "Context/AppContext";
import AuthManager from "Common/AuthManager";
import ServiceWrapper from "Services/ServiceWrapper";
import Spinner from "Components/DesignSystem/Spinner/Spinner";

const DocumentationPage = () => {
  const appData = useContext(AppContext);
  const navigate = useNavigate();
  const [dynamicElement, setDynamicElement] = useState("<div/>")
  const [label, setLabel] = useState("")
  const [selectList, setSelectList] = useState([{
    label: 'Recommender User Guide_V1.5',
    value: 2280980481,
  }
  ])
  const [selectNotes, setSelectNotes] = useState([
    {
      label: 'ARS 1.4.0 Beta',
      value: 2253258808
    },
    {
      label: 'ARS 1.5.0',
      value: 2265841669
    }
  ])
  const [selectedDocument, setSelectedDocument] = useState(selectList[0])
  const [loading, setLoading] = useState(false)
  useEffect(() => {
    if (!appData?.pm?.checkPermission("gmsproducts_read")) {
      navigate("/workspace/module/permission/denied");
    }
  }, [appData.channelKey]);



  const fetchConfluence = async (pageId: any) => {
    const Url = runtimeConfig.GMS_BACKEND_API_URL;
    setLoading(true)
    const res = await ServiceWrapper.doGet(
      `${Url}confluence/get_by_id/${pageId}`,
      null,
      null,
      AuthManager.getGmsToken()
    );
    if (res?.data?.done) {
      setDynamicElement(res?.data?.data?.html);
      setLabel(res?.data?.data?.title)
    }
    setLoading(false)
  };

  const handleDocumentSelect = (option: any) => {
    setSelectedDocument(option)
    fetchConfluence(option?.value)
    console.log(option)
  }

  useEffect(() => {
    if (dynamicElement == "<div/>")
      fetchConfluence(selectedDocument?.value)
  }, [dynamicElement])

  return (
    <>
      <div className={`tw-pt-[12px]`} data-testid="documentation-page">
        <div className={`tw-flex tw-flex-col tw-items-left`}>
          <label className={`tw-text-ink tw-font-noto-sans tw-text-xl tw-font-semibold tw-leading-[25.2px]`} data-testid="documentation-title">
            Documentation
          </label>
        </div>
      </div>
      <div className={`tw-mt-2 tw-box-border tw-w-auto tw-border-t-[1px] tw-border-solid tw-border-lightgray-200`} />
      <div className="tw-grid tw-grid-cols-10">
        <div className="tw-col-span-2 tw-w-[100%] bg-white border border-gray-200" >
          <span className="tw-font-bold tw-ml-1 tw-font-noto-sans">User guides</span>
          {
            selectList && selectList.map(
              option =>
                <button data-testid={`documentation-guide-${option.value}`} key={option?.label}
                  className={`tw-cursor-pointer tw-ml-2 tw-text-start tw-w-[95%] tw-leading-[30px] tw-flex-nowrap hover:tw-bg-surface-hover tw-m-1 ${selectedDocument?.value === option.value ?
                    'tw-bg-accent-tint  tw-text-accent' : 'tw-bg-surface'} tw-font-medium tw-font-['Noto Sans']`}
                  onClick={() => { handleDocumentSelect(option) }}>
                  {option?.label}
                </button>
            )
          }
          <span className="tw-font-bold tw-ml-1 tw-font-noto-sans">Release notes</span>
          {
            selectNotes && selectNotes.map(
              option =>
                <button data-testid={`documentation-release-note-${option.value}`} key={option.label}
                  className={`tw-cursor-pointer tw-ml-2 tw-text-start tw-w-[95%] tw-leading-[30px] tw-flex-nowrap hover:tw-bg-surface-hover tw-m-1 ${selectedDocument?.value === option.value ?
                    'tw-bg-accent-tint  tw-text-accent' : 'tw-bg-surface'} tw-font-medium tw-font-['Noto Sans']`}
                  onClick={() => { handleDocumentSelect(option) }}>
                  {option?.label}
                </button>
            )
          }
        </div>
        <div className="tw-col-span-8 tw-ml-5 tw-h-[840px]">
          <div className="tw-ml-[40%] tw-text-xl tw-font-extrabold tw-leading-[30px]">
            {label}
          </div>
          {
            loading ?

              <div className="tw-flex tw-justify-center tw-py-10 tw-mt-[20%]">
                <Spinner size="lg" label="Loading documentation" showLabel data-testid="documentation-loading" />
              </div>
              :
              <iframe className="tw-w-[100%] tw-h-[95%]"
                title="doc"
                src={"data:text/html," + encodeURIComponent(dynamicElement)}
                allowFullScreen
              />}
        </div>
      </div>
      <div className="w-[907px] h-[0px] left-[513px] top-[946px] absolute border border-gray-400"></div>

    </>
  );
};

export default DocumentationPage;


